<template>
    <div>
        <v-app-bar
            app
            color="white"
            dark
            fixed
            :bottom="$vuetify.breakpoint.mobile"
            flat
            width="100vw"
            :height="$vuetify.breakpoint.mobile ? '60px' : '100px'"
        >
            <v-app-bar-nav-icon class="d-lg-none mr-3" x-large @click.stop="closeDrawer">
                <v-row justify="center">
                    <v-col cols="12" class="px-0 py-0 my-0 mx-0" align="center">
                        <v-icon color="#ac2f37">
                            mdi-menu
                        </v-icon>
                    </v-col>
                    <v-col cols="12" class="px-0 py-0 my-0 mx-0 caption black--text" align="center">
                        Μενού
                    </v-col>
                </v-row>
            </v-app-bar-nav-icon>
            <v-tabs
                class="d-none d-lg-block"
            >
                <img v-if="!$vuetify.breakpoint.mobile" height="80px" contain class="main-logo" :src="require('@/assets/main_logo.png')" @click="$router.push({name: 'News'})">
                <v-tabs-slider style="display: none;" class="custom-orange" />
                <v-tab v-for="(item, index) in navItems.slice(0, -1)" :key="index" :to="`/${item.link}`" class="text-h6">
                    <span>{{ item.name }}</span>
                </v-tab>
                <v-menu
                    transition="slide-y-transition"
                    bottom
                    offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-tab class="text-h6" v-bind="attrs" v-on="on">
                            <span>{{ navItems[navItems.length - 1].name }}</span>
                        </v-tab>
                    </template>
                    <v-list class="submenu-list">
                        <v-row no-gutters class="submenu-row">
                            <v-col
                                v-for="(column, columnIndex) in getSubItemColumns(navItems[navItems.length - 1].subItems, 6)"
                                :key="columnIndex"
                                cols="6"
                                class="submenu-column"
                            >
                                <v-list-item
                                    v-for="(subItem, i) in column"
                                    :key="`${columnIndex}-${i}`"
                                    :to="getSubItemRoute(subItem)"
                                    class="submenu-item"
                                >
                                    <span class="text-h6 custom-orange-text">{{ subItem.name }}</span>
                                </v-list-item>
                            </v-col>
                        </v-row>
                    </v-list>
                </v-menu>
            </v-tabs>
            <div class="top-sports-icons">
                <v-tooltip bottom open-delay="0" close-delay="0">
                    <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" :height="$vuetify.breakpoint.mobile ? '50px' : '80px'" contain class="main-logo" :src="require('@/assets/VOLLEY.png')">
                    </template>
                    <span>Volley</span>
                </v-tooltip>
                <v-tooltip bottom open-delay="0" close-delay="0">
                    <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" :height="$vuetify.breakpoint.mobile ? '50px' : '80px'" contain class="main-logo" :src="require('@/assets/WATER_POLO.png')">
                    </template>
                    <span>Water Polo</span>
                </v-tooltip>
                <v-tooltip bottom open-delay="0" close-delay="0">
                    <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" :height="$vuetify.breakpoint.mobile ? '50px' : '80px'" contain class="main-logo" :src="require('@/assets/PETANQUE.png')">
                    </template>
                    <span>Petanque</span>
                </v-tooltip>
                <v-tooltip bottom open-delay="0" close-delay="0">
                    <template v-slot:activator="{ on, attrs }">
                        <img v-bind="attrs" v-on="on" :height="$vuetify.breakpoint.mobile ? '50px' : '80px'" contain class="main-logo" :src="require('@/assets/kiddy_motion.png')">
                    </template>
                    <span>Kiddy Motion</span>
                </v-tooltip>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            temporary
            disable-resize-watcher
            width="80vw"
            color="white"
            style="z-index: 101;"
        >
            <v-list
                nav
                dense
                class="text-center"
            >
                <v-row>
                    <v-col cols="12" align="start">
                        <v-icon v-if="secondaryOptions" large class="custom-orange-text" @click="secondaryOptions = false">
                            mdi-arrow-left
                        </v-icon>
                    </v-col>
                </v-row>
                <v-list-item-group
                    v-for="(item, index) in getNavItems()"
                    :key="index"
                    active-class="text--accent-4"
                >
                    <v-list-item class="border-bottom">
                        <v-list-item-title class="black--text text-h6" @click="item.subItems ? setMenu() : menuActionClick(item.link)">
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
                <!-- <v-list-item class="border-bottom justify-center">
                    <v-icon large class="custom-orange-text" @click="openSocial('facebook')"> mdi-facebook</v-icon>
                    <v-icon large class="custom-orange-text mx-5" @click="openSocial('instagram')"> mdi-instagram</v-icon>
                    <v-icon large class="custom-orange-text mr-5" @click="openSocial('youtube')"> mdi-youtube </v-icon>
                </v-list-item> -->
            </v-list>
        </v-navigation-drawer>

        <div class="sports-fab-wrapper">
            <v-btn class="sports-fab rounded-l-xl" color="#ac2f37" dark @click="toggleSportsDrawer">
                <v-icon left>
                    {{ currentFabIcon }}
                </v-icon>
                Αθλήματα
            </v-btn>
            <v-scale-transition>
                <div v-show="showSportsDrawer" class="sports-floating-drawer">
                    <v-tooltip
                        v-for="sport in sportsWithIcons"
                        :key="sport.id"
                        left
                        open-delay="0"
                        close-delay="0"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <button
                                v-bind="attrs"
                                type="button"
                                class="sport-icon-btn"
                                v-on="on"
                                @click="navigateToSportById(sport.id)"
                            >
                                <img :src="sport.iconSrc" :alt="sport.title || `Sport ${sport.id}`" class="sport-icon-image">
                            </button>
                        </template>
                        <span>{{ sport.title || `Sport ${sport.id}` }}</span>
                    </v-tooltip>
                </div>
            </v-scale-transition>
        </div>
    </div>
</template>

<script>
    import sportService from '@/services/sport'

    export default {
        name: 'NavBar',
        data() {
            return {
                drawer: false,
                secondaryOptions: false,
                showSportsDrawer: false,
                fabIconIndex: 0,
                fabIconIntervalId: null,
                fabIcons: ['mdi-basketball', 'mdi-water-polo', 'mdi-volleyball', 'mdi-soccer', 'mdi-weight-lifter'],
                assetsUrl: process.env.VUE_APP_GOOGLE_STORAGE_API,
                sports: [],
                sportIcons: [
                    {
                        key: 'volley',
                        label: 'Volley',
                        src: require('@/assets/VOLLEY.png'),
                        keywords: ['volley', 'volleyball', 'βόλεϊ', 'βολεϊ', 'πετοσφαιριση']
                    },
                    {
                        key: 'water_polo',
                        label: 'Water Polo',
                        src: require('@/assets/WATER_POLO.png'),
                        keywords: ['water polo', 'waterpolo', 'πόλο', 'πολο', 'υδατοσφαίριση', 'υδατοσφαιριση']
                    },
                    {
                        key: 'petanque',
                        label: 'Petanque',
                        src: require('@/assets/PETANQUE.png'),
                        keywords: ['petanque', 'πετάνκ', 'πετανκ']
                    },
                    {
                        key: 'kiddy_motion',
                        label: 'Kiddy Motion',
                        src: require('@/assets/kiddy_motion.png'),
                        keywords: ['kiddy', 'motion', 'kids', 'παιδ']
                    }
                ],
                navItems: [
                    {
                        name: 'Νέα',
                        link: 'News'
                    },
                    {
                        name: 'Ιστορία',
                        link: 'History'
                    },
                    // {
                    //     name: 'Βαθμολογία',
                    //     link: 'Standings'
                    // },
                    // {
                    //     name: 'Match Center',
                    //     link: 'Schedule'
                    // },
                    // {
                    //     name: 'Ομάδα',
                    //     link: 'Teams'
                    // },
                    // {
                    //     name: 'Τίτλοι',
                    //     link: 'Stats'
                    // },
                    // {
                    //     name: 'Γήπεδο',
                    //     link: 'Courts'
                    // },
                    // {
                    //     name: 'Ακαδημίες',
                    //     link: 'Profile'
                    // },
                    {
                        name: 'Τμήματα',
                        link: '',
                        subItems: []
                    }
                ]
            }
        },
        created() {
            this.fetchSports()
        },
        mounted() {
            this.startFabIconRotation()
        },
        beforeDestroy() {
            this.stopFabIconRotation()
        },
        computed: {
            currentFabIcon() {
                if (this.showSportsDrawer) {
                    return 'mdi-close'
                }

                return this.fabIcons[this.fabIconIndex] || 'mdi-basketball'
            },
            sportsWithIcons() {
                const rows = Array.isArray(this.sports) ? this.sports : []

                return rows
                    .filter(sport => sport && sport.id !== undefined && sport.id !== null)
                    .map(sport => ({
                        ...sport,
                        iconSrc: this.getSportIconUrl(sport)
                    }))
                    .filter(sport => !!sport.iconSrc)
            }
        },
        methods: {
            startFabIconRotation() {
                this.stopFabIconRotation()
                this.fabIconIntervalId = setInterval(() => {
                    if (!Array.isArray(this.fabIcons) || this.fabIcons.length === 0) {
                        return
                    }

                    this.fabIconIndex = (this.fabIconIndex + 1) % this.fabIcons.length
                }, 2000)
            },
            stopFabIconRotation() {
                if (this.fabIconIntervalId) {
                    clearInterval(this.fabIconIntervalId)
                    this.fabIconIntervalId = null
                }
            },
            fetchSports() {
                sportService.getAllSports(1, 0)
                    .then(resp => {
                        const sports = resp && resp.data && Array.isArray(resp.data.data) ? resp.data.data : []
                        this.sports = sports

                        const mappedSports = sports
                            .filter(sport => sport && sport.id !== undefined && sport.id !== null)
                            .map(sport => ({
                                name: sport.title || `Sport ${sport.id}`,
                                link: String(sport.id)
                            }))

                        this.$set(this.navItems[this.navItems.length - 1], 'subItems', mappedSports)
                    })
                    .catch(() => {
                        this.sports = []
                        this.$set(this.navItems[this.navItems.length - 1], 'subItems', [])
                    })
            },
            toggleSportsDrawer() {
                this.showSportsDrawer = !this.showSportsDrawer
            },
            getSportIconUrl(sport) {
                if (!sport || typeof sport !== 'object') {
                    return ''
                }

                const icon = sport.iconImage || null

                if (typeof icon === 'string' && icon) {
                    return icon.startsWith('http') ? icon : `${process.env.VUE_APP_GOOGLE_BUCKET_URL}${icon}`
                }

                if (icon && typeof icon === 'object' && icon.imageName) {
                    return `${process.env.VUE_APP_GOOGLE_BUCKET_URL}${icon.imageName}`
                }

                return ''
            },
            navigateToSportById(sportId) {
                if (sportId === undefined || sportId === null) {
                    return
                }

                this.showSportsDrawer = false
                this.drawer = false

                const targetTeam = String(sportId)
                if (this.$route.name === 'Team' && String(this.$route.params.team) === targetTeam) {
                    return
                }

                this.$router.push({ name: 'Team', params: { team: targetTeam } })
            },
            getSportRouteByKey(sportKey) {
                const icon = this.sportIcons.find(item => item.key === sportKey)
                const normalizedSports = Array.isArray(this.sports) ? this.sports : []

                if (!icon || normalizedSports.length === 0) {
                    return { name: 'News' }
                }

                const matchingSport = normalizedSports.find((sport) => {
                    const title = sport && sport.title ? String(sport.title).toLowerCase() : ''
                    return icon.keywords.some(keyword => title.includes(keyword))
                })

                if (matchingSport && matchingSport.id !== undefined && matchingSport.id !== null) {
                    return { name: 'Team', params: { team: String(matchingSport.id) } }
                }

                const iconIndex = this.sportIcons.findIndex(item => item.key === sportKey)
                const fallbackSport = normalizedSports[iconIndex]

                if (fallbackSport && fallbackSport.id !== undefined && fallbackSport.id !== null) {
                    return { name: 'Team', params: { team: String(fallbackSport.id) } }
                }

                return { name: 'News' }
            },
            getSubItemColumns(items, itemsPerColumn) {
                const columns = []

                for (let index = 0; index < items.length; index += itemsPerColumn) {
                    columns.push(items.slice(index, index + itemsPerColumn))
                }

                return columns
            },
            getSubItemRoute(subItem) {
                if (!subItem || !subItem.link) {
                    return null
                }

                return { name: 'Team', params: { team: String(subItem.link) } }
            },
            closeDrawer() {
                if (this.secondaryOptions) {
                    this.secondaryOptions = false
                    this.getNavItems()
                    if (!this.drawer) {
                        this.drawer = !this.drawer
                    }
                } else {
                    this.drawer = !this.drawer
                }
            },
            setMenu() {
                this.secondaryOptions = true
            },
            getNavItems() {
                if (this.secondaryOptions) {
                    return this.navItems[this.navItems.length - 1].subItems
                } else {
                    return this.navItems
                }
            },
            menuActionClick(link) {
                if (!link) {
                    return
                }

                if (this.secondaryOptions) {
                    const sportId = String(link)
                    if (this.$route.name === 'Team' && String(this.$route.params.team) === sportId) {
                        this.drawer = false
                        return
                    }

                    this.$router.push({ name: 'Team', params: { team: sportId } })
                    this.drawer = false
                    return
                }

                if (link === this.$route.name) {
                    this.drawer = false
                } else {
                    this.$router.push({ name: link })
                }
            },
            openSocial(social) {
                if (social === 'facebook') {
                    window.open('https://www.facebook.com/backinthegamegr', '_blank')
                } else if (social === 'instagram') {
                    window.open('https://www.instagram.com/backinthegame_2012/', '_blank')
                } else if (social === 'youtube') {
                    window.open('https://www.youtube.com/@BackIntheGameBasketball', '_blank')
                } else if (social === 'tiktok') {
                    window.open('https://www.tiktok.com/@backinthegame2012', '_blank')
                }
            }
        }
    }
</script>

<style>
.v-list-item--active {
    color: transparent !important;
}
</style>

<style scoped>

.v-application .caption {
    font-size: 0.75rem !important;
    letter-spacing: 0.0333333333em !important;
    line-height: 1.25rem;
    font-family: Arial, sans-serif !important;
    text-transform: capitalize;
}

.text-h6 {
    font-size: 1.25rem !important;
    letter-spacing: 0.0125em !important;
    line-height: 2rem;
    font-family: Arial, sans-serif !important;
}

.v-overlay__scrim {
    opacity: 0 !important;
}

.v-tabs {
    width: 50% !important;
}

.v-tab {
    font-weight: bolder;
    font-size: 15px;
    color: #223152 !important;
    text-transform: none !important;
}

.v-tab::before {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    background-color: transparent;
}

.main-logo {
    align-self: center;
}

.menu-item:hover {
    color: #f7941e;
    cursor: pointer !important;
}

.v-navigation-drawer--absolute {
    width: 100vw !important;
    height: auto;
}

.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
    line-height: 3.7;
    align-self: center;
    font-size: 1.5rem;
    color: orange;
    font-weight: bolder;
    opacity: 1 !important;
}

.submenu-list {
    padding: 8px 12px;
}

.submenu-row {
    min-width: 520px;
}

.submenu-column {
    padding: 0 8px;
}

.submenu-item {
    min-height: 42px;
}

.top-sports-icons {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
}

.sports-fab-wrapper {
    position: fixed;
    right: 0px;
    top: 110px;
    z-index: 120;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
}

.sports-fab {
    text-transform: none !important;
    font-weight: 700;
    letter-spacing: 0.01em;
    min-width: 132px !important;
}

.sports-floating-drawer {
    background: #ffffff;
    border-radius: 18px;
    padding: 10px 8px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.22);
    display: flex;
    align-items: center;
    gap: 8px;
}

.sport-icon-btn {
    border: 0;
    background: transparent;
    cursor: pointer;
    border-radius: 12px;
    padding: 4px;
    transition: transform 0.2s ease;
}

.sport-icon-btn:hover,
.sport-icon-btn:focus {
    transform: translateY(-2px);
    outline: none;
}

.sport-icon-image {
    width: 56px;
    height: 56px;
    object-fit: contain;
    display: block;
}

@media (max-width: 960px) {
    .sports-fab-wrapper {
        right: 12px;
        top: 70px;
    }

    .sports-floating-drawer {
        padding: 8px 6px;
        gap: 6px;
    }

    .sport-icon-image {
        width: 48px;
        height: 48px;
    }
}
</style>
